module.exports = __webpack_public_path__ + "static/media/rejectedStatus.2fc4e852.svg";